export default class Logger {
  public static error(error: Error) {
    console.error(error.message);
  }
}
